export const getLessonDeclension = (t, n) => t(`student~занят${n % 100 >= 11 && n % 100 <= 14 ? "ь" : (n % 10 === 1 ? "тя" : "ь")}`);
